import { UnitOfMeasurementType } from './unit-of-measurement-type';

export interface UnitOfMeasurement {
    id: number;
    name: string;
    isBaseUnit: boolean;
    factor: number;
    unitOfMeasurementType: UnitOfMeasurementType;
}
